import { AuditLogEntityType } from "generated/CoreApi_v1";
import { AuditLogDialog } from "views/common/AuditLog/AuditLogDialog";
import React from "react";

////////////////////////////////////////////////////////////////////////////////

interface IPros {
    publicationId: string;
    title: string;
    onClose: () => void;
}

export const PublicationLogDialog = (props: IPros) => {
    const { publicationId, title, onClose } = props;

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <AuditLogDialog
            entityType={AuditLogEntityType.Publication}
            entityKey={[publicationId]}
            title={title}
            onClose={onClose}
        />
    );
};
